import React from 'react';
import { X, Check } from 'lucide-react';
import { FadeIn } from './ui/FadeIn';
export function Transformacion() {
  const antes = ['Tu zurda es tu característica pero no tu arma', 'Siempre te limitan al extremo izquierdo', 'Tus rivales se adaptan rápido a tu zurda', 'Perdés goles fáciles por falta de técnica'];
  const despues = ['Tu zurda es el arma que nadie sabe parar', 'Jugás en cualquier posición con ventaja', 'Tus rivales nunca se acostumbran a tu juego', 'Definís con precisión y potencia desde cualquier ángulo'];
  return <section className="py-16 bg-white relative" data-id="element-288">
      <div className="container mx-auto px-4 max-w-5xl" data-id="element-289">
        <FadeIn data-id="element-290">
          <h2 className="font-display text-3xl md:text-4xl font-black text-center mb-10 uppercase text-navy" data-id="element-291">
            Tu juego zurdo hoy{' '}
            <span className="text-celeste" data-id="element-292">vs. en 30 días</span>
          </h2>
        </FadeIn>

        <div className="grid md:grid-cols-2 gap-0 rounded-2xl overflow-hidden shadow-xl border border-gray-200" data-id="element-293">
          {/* ANTES */}
          <div className="bg-lightbg p-8 md:p-10 border-b md:border-b-0 md:border-r border-gray-200" data-id="element-294">
            <h3 className="font-display text-xl font-bold text-red-500 mb-6 uppercase text-center" data-id="element-295">
              Sin el Zurdo Master Pack
            </h3>
            <ul className="space-y-5" data-id="element-296">
              {antes.map((item, idx) => <li key={idx} className="flex items-start gap-3 text-gray-600 text-base" data-id="element-297">
                  <X className="w-5 h-5 text-red-500 flex-shrink-0 mt-0.5" data-id="element-298" />
                  <span data-id="element-299">{item}</span>
                </li>)}
            </ul>
          </div>

          {/* DESPUÉS */}
          <div className="bg-navy p-8 md:p-10 relative overflow-hidden" data-id="element-300">
            <div className="absolute top-0 right-0 w-64 h-64 bg-celeste/10 blur-[80px] rounded-full pointer-events-none" data-id="element-301"></div>
            <h3 className="font-display text-xl font-bold text-celeste mb-6 uppercase text-center relative z-10" data-id="element-302">
              Con el Zurdo Master Pack
            </h3>
            <ul className="space-y-5 relative z-10" data-id="element-303">
              {despues.map((item, idx) => <li key={idx} className="flex items-start gap-3 text-white font-bold text-base" data-id="element-304">
                  <div className="bg-celeste/20 rounded-full p-0.5 flex-shrink-0 mt-0.5" data-id="element-305">
                    <Check className="w-4 h-4 text-celeste" data-id="element-306" />
                  </div>
                  <span data-id="element-307">{item}</span>
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}